import { h, Host } from "@stencil/core";
import { debounce } from "../../utils/debounce";
const baseClass = "ux-scrollable-container";
export class UxScrollableContainer {
    constructor() {
        this.scrollbarPlacement = "top";
        this.width = 0;
        this.scroll = 0;
    }
    host;
    /** active grabbing */
    isDragging = false;
    scrollElement;
    hostWidth = 0;
    scrollWidth = 0;
    eventMouseMove;
    eventMouseUp;
    componentDidLoad() {
        const scrollTarget = this.host.querySelector("[data-scroll-target]");
        // @ts-expect-error Check for typing
        this.scrollElement = scrollTarget !== null ? scrollTarget : this.host.querySelector(`.${baseClass}__scroll`);
        this.updateSizes();
        this.addScrollListener();
        this.addResizeListener();
        this.observeMutations();
    }
    updateSizes() {
        this.hostWidth = this.host.clientWidth;
        this.scrollWidth = this.scrollElement.scrollWidth;
        this.width = this.hostWidth / this.scrollWidth;
    }
    updateSizesDebounced = debounce(() => {
        this.updateSizes();
    }, 100);
    observeMutations() {
        const targetNode = this.scrollElement;
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = (mutationList) => {
            for (const mutation of mutationList) {
                /* eslint-disable-next-line no-console */
                console.log(mutation.type);
                this.updateSizesDebounced();
            }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }
    addResizeListener = debounce(() => {
        window.addEventListener("resize", this.updateSizes.bind(this));
    }, 100);
    addScrollListener = debounce(() => {
        this.scrollElement.addEventListener("scroll", () => {
            const setScroll = () => {
                this.scroll = this.scrollElement.scrollLeft / this.scrollWidth;
            };
            requestAnimationFrame(() => {
                setScroll();
            });
        }, { passive: true });
    }, 100);
    handleDragStart() {
        this.isDragging = true;
        this.host.style.cursor = "grabbing";
        this.eventMouseMove = this.handleDragMove.bind(this);
        this.eventMouseUp = this.handleDragEnd.bind(this);
        document.addEventListener("mousemove", this.eventMouseMove);
        document.addEventListener("mouseup", this.eventMouseUp);
    }
    handleDragMove(e) {
        if (!this.isDragging) {
            return;
        }
        const scrollRelation = e.movementX / this.host.clientWidth;
        this.scrollElement.scrollLeft = this.scrollElement.scrollLeft + scrollRelation * this.scrollWidth;
    }
    handleDragEnd() {
        this.isDragging = false;
        this.host.style.cursor = "auto";
        document.removeEventListener("mousemove", this.eventMouseMove);
        document.removeEventListener("mouseup", this.eventMouseUp);
    }
    getScrollBar() {
        return (h("div", { class: `${baseClass}__track`, style: {
                marginLeft: `${this.scroll * 100}%`,
                width: `${this.width * 100}%`,
                display: this.width >= 1 ? "none" : undefined
            }, onMouseDown: this.handleDragStart.bind(this) }));
    }
    render() {
        return (h(Host, { key: '3f086fe816bdc09fd7bd5f6ee75b35f52dd1bdd1', class: baseClass }, (this.scrollbarPlacement === "top" || this.scrollbarPlacement === "top-bottom") && this.getScrollBar(), h("div", { key: 'd3f6d683044c49577f036c3ccc32ea7a624d4767', class: `${baseClass}__scroll` }, h("slot", { key: '90a7578d314b917cf4746915350eb26e4b780489' })), (this.scrollbarPlacement === "bottom" || this.scrollbarPlacement === "top-bottom") && this.getScrollBar()));
    }
    static get is() { return "ux-scrollable-container"; }
    static get originalStyleUrls() {
        return {
            "$": ["scrollable-container.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["scrollable-container.css"]
        };
    }
    static get properties() {
        return {
            "scrollbarPlacement": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"top\" | \"bottom\" | \"top-bottom\"",
                    "resolved": "\"bottom\" | \"top\" | \"top-bottom\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set scrollbar placement"
                },
                "attribute": "scrollbar-placement",
                "reflect": false,
                "defaultValue": "\"top\""
            }
        };
    }
    static get states() {
        return {
            "width": {},
            "scroll": {}
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=scrollable-container.js.map
